import { Link, type LinkProps } from 'react-router';

import { clsx } from '~/styles/utils';

import { Icon } from '../Icon/Icon';
import { itemLinkStyle, itemStyle, labelStyle, limitedLabelStyle, separatorStyle } from './Breadcrumb.css';

type Props = { limitWidth?: boolean } & LinkProps;

export const BreadcrumbLink = ({ children, className, limitWidth = false, to, ...delegated }: Props) => {
  return (
    <li className={clsx(itemStyle, className)}>
      <Icon className={separatorStyle} name="ChevronForward" />

      <Link {...delegated} className={clsx(itemLinkStyle, labelStyle, limitWidth && limitedLabelStyle)} to={to}>
        {children}
      </Link>
    </li>
  );
};
